module.exports = __webpack_public_path__ + "img/Apk.83eedc12.svg";